"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranscriptsService = void 0;
var OpenAPI_1 = require("../core/OpenAPI");
var request_1 = require("../core/request");
var TranscriptsService = /** @class */ (function () {
    function TranscriptsService() {
    }
    /**
     * Initiate Transcript Job
     * @returns any Successful Response
     * @throws ApiError
     */
    TranscriptsService.initiateTranscriptJob = function () {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/transcripts',
        });
    };
    /**
     * Get Transcripts Results
     * @param jids The job ids returned by the transcript POST endpoint
     * @returns AugmentedTranscriptionJob Successful Response
     * @throws ApiError
     */
    TranscriptsService.getTranscriptsResults = function (jids) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/transcripts/multiple',
            query: {
                'jids': jids,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Update Transcript Speakers
     * @param jid The job id related to the transcript
     * @param requestBody
     * @returns AugmentedTranscriptionJob Success
     * @throws ApiError
     */
    TranscriptsService.updateTranscriptSpeakers = function (jid, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/transcripts/{jid}/update-speakers',
            path: {
                'jid': jid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Get Transcripts Result
     * https://www.notion.so/
     * ateams/Transcripts-endpoint-specification-95f1070816df460b88445bcd36c43358?pvs=4
     * Get the state and json transcript of a transcript job.
     * The json besides the transcript contains:
     * - Speaker information
     * - Filler words are transcribed as well
     * - Punctuations
     * - Topic detection
     * - Entity detection
     * - Summary
     * @param jid The job id returned by the transcript POST endpoint
     * @returns AugmentedTranscriptionJob Success
     * @throws ApiError
     */
    TranscriptsService.getTranscriptsResult = function (jid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/transcripts/{jid}',
            path: {
                'jid': jid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    /**
     * Delete Transcripts Result
     * @param uid The user id for which we delete transcripts and recordings.
     * @returns TranscriptionJobIds Success
     * @throws ApiError
     */
    TranscriptsService.deleteTranscriptsResult = function (uid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/transcripts/{uid}',
            path: {
                'uid': uid,
            },
            errors: {
                422: "Validation Error",
            },
        });
    };
    return TranscriptsService;
}());
exports.TranscriptsService = TranscriptsService;
//# sourceMappingURL=TranscriptsService.js.map